import React from "react";

export const Utils = React.createContext(null);
